import { Action } from 'helpers/action-helpers';
import { NmvsMenuItem } from 'types/nmvs-menu-item';

export const SET_MENU_OPERATION = 'SetMenuOperationAction';
export const OPEN_MOBILE_MENU = 'OpenMobileMenuAction';
export const CLOSE_MOBILE_MENU = 'CloseMobileMenuAction';

export class SetMenuOperationAction extends Action {
  constructor(public menuOperation: NmvsMenuItem) {
    super(SET_MENU_OPERATION);
  }
}

export class OpenMobileMenuAction extends Action {
  constructor() {
    super(OPEN_MOBILE_MENU);
  }
}
export class CloseMobileMenuAction extends Action {
  constructor() {
    super(CLOSE_MOBILE_MENU);
  }
}


// WEBPACK FOOTER //
// ./src/components/menu/actions.ts